import React, { useEffect, useState, forwardRef } from 'react';
import { Pannellum } from 'pannellum-react';
import '../styles/Hotspot.css';
import { useViewerState } from '../components/useViewerState';
import { Button } from '../components/ui/button'; // ✅ correct if 'button.js' exists here
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '../components/ui/collapsible'; // adjust path if needed
import { ChevronDown } from 'lucide-react';

// Reusable Pannellum Viewer component
const PannellumViewer = forwardRef(({
  mediaPhoto,
  currentRoomInfo,
  hotspots,
  currentRoom,
  startPoints,
  rooms,
  canEdit,
  previewView,
  handleRoomChange,
  handleNextRoom,
  handlePreviousRoom,
  onViewUpdate,
  thumbnailUrls,
  hotspotDebug,
  pannellumRef: externalRef, // Accept external ref for measurements
}, ref) => {
  // Use external ref if provided, otherwise use internal ref
  const internalViewerState = useViewerState(startPoints, currentRoom, onViewUpdate);
  const actualPannellumRef = externalRef || internalViewerState.pannellumRef;
  const { yaw, pitch, hfov } = internalViewerState.viewerState;
  const { handleMouseDown, handleMouseUp } = internalViewerState;

  // Forward the ref to the parent component
  React.useImperativeHandle(ref, () => ({
    getViewer: () => actualPannellumRef.current?.getViewer(),
    pannellumRef: actualPannellumRef.current,
  }), [actualPannellumRef]);
  // debugger;
  useEffect(() => {
    if (actualPannellumRef.current) {
      const viewer = actualPannellumRef.current.getViewer();
      console.log('Pannellum Viewer:', viewer); // Check if the viewer is properly initialized
    }
  }, [mediaPhoto, hotspots, currentRoom, actualPannellumRef]);
  // console.log(hotspots);
  // console.log(currentRoom);
  // debugger;
  const [viewerSize, setViewerSize] = useState({ width: '100px', height: '100px' });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // const [notes, setNotes] = useState([]); // array of { roomId, yaw, pitch, note }
  // useEffect(() => {
  //   const viewer = pannellumRef.current?.getViewer();
  //   if (!viewer || !isNoteMode) return;
  //
  //   const handleClick = e => {
  //     const pitch = viewer.getPitch();
  //     const yaw = viewer.getYaw();
  //
  //     const noteText = prompt('Enter note:');
  //     if (noteText) {
  //       const newNote = {
  //         roomId: currentRoom,
  //         yaw,
  //         pitch,
  //         note: noteText,
  //       };
  //       setNotes(prev => [...prev, newNote]);
  //
  //       // 🔁 Optionally send to DB
  //       // axios.post(`${API_BASE_URL}/api/post`, {
  //       //   function_name: 'SAVE_NOTE',
  //       //   payload: {
  //       //     spaceId: currentRoomInfo?.spaceId,
  //       //     roomId: currentRoom,
  //       //     yaw,
  //       //     pitch,
  //       //     note: noteText,
  //       //   },
  //       // });
  //     }
  //   };
  //
  //   viewer.on('mousedown', handleClick);
  //   return () => viewer.off('mousedown', handleClick);
  // }, [isNoteMode, currentRoom]);

  useEffect(() => {
    const updateSize = () => {
      const headerHeight = 160; // Adjust if your header/selector height is different
      const height = window.innerHeight - headerHeight;
      const width = window.innerWidth;
      const adjustedHeight = canEdit ? height / 2 : height;
      const adjustedWidth = canEdit ? width / 2 : width;

      setViewerSize({
        width: `${adjustedWidth}px`,
        height: `${adjustedHeight}px`,
      });
    };

    updateSize(); // Set initial size

    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, [canEdit]);
  return (
    <div className="relative ">
      {/*<div className="relative">{JSON.stringify(currentRoomInfo)}</div>*/}
      {/*<div className="relative">{JSON.stringify(currentRoom)}</div>*/}
      {/*<div className="relative">{JSON.stringify(hotspots)}</div>*/}

      <div>
        {/*{yaw}*/}
        {/*{pitch}*/}
        <Pannellum
          ref={actualPannellumRef}
          width={viewerSize.width}
          height={viewerSize.height}
          image={mediaPhoto}
          pitch={pitch}
          yaw={yaw}
          hfov={hfov}
          onTouchend={handleMouseDown}
          onTouchstart={handleMouseUp}
          autoLoad
          title={currentRoomInfo?.name}
          hotspotDebug={hotspotDebug}
          showControls={true}
          draggable={true}
          mouseZoom={true}
          onMousedown={handleMouseDown}
          onMouseup={handleMouseUp}
          onError={error => {
            console.error('Error loading panorama:', error);
          }}
        >
          {(hotspots[currentRoom] || []).map((hotspot, index) => (
            <Pannellum.Hotspot
              key={`${currentRoom}-${index}`}
              type="custom"
              pitch={hotspot.pitch}
              yaw={hotspot.yaw}
              handleClick={(evt, args) => handleRoomChange(hotspot.targetRoom)}
              cssClass="custom-hotspot my-custom-hotspot"
              text={`Go to ${hotspot.targetRoom}`}
            />
          ))}
        </Pannellum>
      </div>

      {/* 🟦 Embedded Room Selector */}
      {!canEdit && !previewView && (
        <Collapsible
          open={isSidebarOpen}
          onOpenChange={setIsSidebarOpen}
          className="absolute top-4 right-2 min-w-[180px] max-w-[280px] z-10"
        >
          {' '}
          <CollapsibleTrigger asChild onClick={() => setIsSidebarOpen(prev => !prev)}>
            <button className="w-full text-right flex justify-between items-center text-white bg-black/70 backdrop-blur-md px-4 py-2 rounded-md shadow-md hover:bg-black/60 transition">
              <span className="flex-1 text-right leading-tight">
                {rooms.find(r => r.id === currentRoom)?.name || 'בחר חדר'}
              </span>
              <ChevronDown className={`h-4 w-4 ml-2 flex-shrink-0 transition-transform ${isSidebarOpen ? 'rotate-180' : ''}`} />
            </button>
          </CollapsibleTrigger>
          <CollapsibleContent className="bg-black/80 backdrop-blur-md mt-2 p-4 rounded-md shadow-lg max-h-[70vh] overflow-y-auto">
            <div className="space-y-1">
              {rooms.map(room => {
                const isSelected = currentRoom === room.id;
                return (
                  <button
                    key={room.id}
                    className={`block w-full text-right text-sm py-1.5 px-3 rounded transition-all ${
                      isSelected 
                        ? 'bg-blue-500/30 text-blue-300 border-l-2 border-blue-400' 
                        : 'text-gray-300 hover:bg-white/10 hover:text-white'
                    }`}
                    onClick={() => {
                      handleRoomChange(room.id);
                      setIsSidebarOpen(false);
                    }}
                  >
                    {room.name}
                  </button>
                );
              })}
            </div>
          </CollapsibleContent>
        </Collapsible>
      )}

      {/* 🔽 Bottom Thumbnail Strip */}

      {!canEdit && !previewView && rooms.length > 0 && (
        <div
          className={`absolute bottom-4 z-10 px-6 transition-all duration-300 ${
            isSidebarOpen ? 'left-0 right-[280px]' : 'left-0 right-0'
          } max-h-[20vh] min-h-[90px] sm:min-h-[110px] overflow-y-hidden`}
        >
          <div className="overflow-x-auto">
            <div className="flex gap-3">
              {rooms.map(room => {
                const isActive = room.id === currentRoom;
                const thumbnail = thumbnailUrls[room.thumbnailKey];

                return (
                  <div
                    key={room.id}
                    className={`flex flex-col items-center justify-center cursor-pointer border rounded-md p-2 transition ${
                      isActive ? 'bg-blue-100 ring-2 ring-blue-500' : 'bg-white/80'
                    }`}
                    onClick={() => handleRoomChange(room.id)}
                  >
                    <div className="w-12 sm:w-14 md:w-16 aspect-video">
                      <img
                        src={thumbnail || ''}
                        alt={room.name}
                        className="w-full h-full object-cover rounded-md"
                      />
                    </div>
                    {/*<span className="text-xs mt-1 font-medium text-gray-800">{room.name}</span>*/}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {!canEdit && !previewView && (
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 z-10 flex gap-6">
          <Button
            variant="ghost"
            onClick={handlePreviousRoom}
            disabled={currentRoom === 1}
            className="rounded-full bg-white/80 hover:bg-white text-black shadow-md"
          >
            ←
          </Button>
          <Button
            variant="ghost"
            onClick={handleNextRoom}
            disabled={currentRoom === rooms.length}
            className="rounded-full bg-white/80 hover:bg-white text-black shadow-md"
          >
            →
          </Button>
        </div>
      )}
      {/*{JSON.stringify(notes)}*/}
      {/*{notes*/}
      {/*  .filter(n => n.roomId === currentRoom)*/}
      {/*  .map((note, i) => (*/}
      {/*    <Pannellum.Hotspot*/}
      {/*      key={`note-${i}`}*/}
      {/*      type="info"*/}
      {/*      pitch={note.pitch}*/}
      {/*      yaw={note.yaw}*/}
      {/*      text={note.note}*/}
      {/*      cssClass="custom-note-hotspot"*/}
      {/*    />*/}
      {/*  ))}*/}
      {/*<Button className="absolute top-4 left-4 z-20" onClick={() => setIsNoteMode(prev => !prev)}>*/}
      {/*  {isNoteMode ? 'Exit Note Mode' : 'Enter Note Mode'}*/}
      {/*</Button>*/}
    </div>
  );
});

export default PannellumViewer;
